<style scoped lang="scss">
  .wrap-sanger{
    .title{
      font-size: 24px;
      font-weight: bold;
    }
    .address{
      background: #F9F9F9;
      padding:15px 20px;
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }
    .edit{
      color:#014492;
    }
    .opera{
      height: 222px;
      padding:20px;
      border: 1px dashed #DCDFE6;
    }
  }
  .last1{
    display: block;
  }
  .last{
    display: none;
  }
  @media screen  and (max-width: 640px){
    .container{
      padding-bottom: 20px;
      width: 90% !important;
      overflow: auto;
      overflow-x: hidden;
    }
    .last1{
      display: none!important;
    }
    .last{
      float: right;
      margin-bottom: 20px;
      display: block!important;
    }
    .el-col-17{
      width: 100% !important;
    }
    .el-col-7{
      margin-top: 20px;
      width: 100% !important;
    }
  }
</style>
<template>
  <div class="wrap wrap-sanger" v-loading="submitLoading">
    <section class="container">
      <div class="title">Sanger测序发起取样</div>
      <qk-edit-address/>
      <el-row :gutter="30" class="mt30">
        <el-col :span="17">
          <el-input
            type="textarea"
            :rows="10"
            maxlength="100"
            placeholder="请输入取样备注信息"
            v-model="remark"></el-input>
            <div class="mt10 text-gray9">仅填写本次送样相关信息，若无可不填写</div>
        </el-col>
        <el-col :span="7">
          <div class="opera">
            <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E4%B8%80%E4%BB%A3%E6%B5%8B%E5%BA%8F%E7%99%BB%E8%AE%B0%E5%8D%95.xlsx" class="text-primary"><span class="el-icon-download"></span> 模板下载</a>
            <p class="text-gray9 mt10">如果您需要提交电子订单，请下载标准“
              样品订单模板”，编辑样品信息并上传</p>
            <el-upload
              class="upload-demo"
              :action="uploadFilePath"
              :headers="headers"
              :on-success="handUploadFile">
              <p class="text-primary mt20"><span class="el-icon-upload2"></span> 样品信息上传</p>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <div class="tr">
<!--        <el-button type="primary" class="mt30" @click="noteDialogVisible = true">提交信息</el-button>-->
        <el-button type="primary" class="mt30 last1" @click="onsubmit" v-preventReClick>提交信息</el-button>
        <el-button type="primary" class="mt30 last" size="mini" @click="onsubmit" v-preventReClick>提交信息</el-button>
      </div>
    </section>
    <!--提示弹框-->
    <el-dialog
      title="提示"
      :visible.sync="noteDialogVisible"
      width="35%">
      <span>今日获取验证码次数已超出上限，请明日再试，或使用账号密码登陆。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noteDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="noteDialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
    <orderSangerMask/>
  </div>
</template>

<script>
import { brindOrders, customerUsers } from '@/services/api.index'
import orderSangerMask from './order_sanger_mask.vue'
import {getAddressByMember} from "../../utils/baseMethod";
export default {
  components: {
    orderSangerMask
  },
  data () {
    return {
      remark: '',
      noteDialogVisible: false,
      showAddress: false,
      headers: {},
      uploadFilePath: '',
      file: '',
      fileName: '',
      submitLoading: false,
      userInfo: {}
    }
  },
  created() {
    const BASE_API = process.env.BASE_API
    const userInfo = this.baseMethods.getLocalObj('userInfo')
    this.uploadFilePath = BASE_API + 'file/v1'
    this.headers.Authorization = `Bearer ${userInfo.token}`
  },
  mounted() {},
  methods: {
    getUser() {
      const vm = this
    },
    // 上传文件成功回调
    handUploadFile (file) {
      this.file = file.data.url
      this.fileName = file.data.realName
    },
    // 发起取样
    async onsubmit () {
      const vm = this
      const { remark, file, fileName } = this
      await this.getUser()
      customerUsers().then((res) => {
        console.info(res.data)
        vm.userInfo = res.data
        let address = vm.baseMethods.getAddressByMember(res.data)
        console.info('address resolved.', address)
        // if (remark === '') {
        //   return vm.$message.error('测序取样备注信息未填写')
        // }
        vm.$confirm('是否确认填写的测序取样备注信息与本次送样有关?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          vm.submitLoading = true
          setTimeout(function() {
            brindOrders(remark, file, address, fileName).then(() => {
              vm.submitLoading = false
              vm.$message.success('提交成功')
              vm.$router.push('/tec/success_submit?type=sanger')
            })
          }, 200)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/order_sanger.vue